import pluralize from 'pluralize'

import { ProgressBar } from '@/components/ui'
import {
  isTrialPlan,
  TRIAL_PAGE_ALLOWANCE,
  useAccount,
  useSummary,
} from '@/modules/account'
import { UpgradeButton } from '@/modules/auth'
import { daysUntil, humanizeDate } from '@/utils'

const PERCENT = 100

const daysLeftLabel = (trialEndsAt: string) => {
  const daysLeft = Math.max(0, daysUntil(trialEndsAt))
  return `${daysLeft} ${pluralize('day', daysLeft)} left`
}

export const TrialUsage = () => {
  const account = useAccount()
  const summary = useSummary()
  if (!isTrialPlan(account?.planKind)) return

  const pagesLeft = Math.max(0, summary?.pagesCredits ?? 0)
  const trialEndsAt = account?.trialEndsAt

  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex flex-col gap-1 text-xs text-muted-foreground">
        <span>
          <strong className="font-semibold text-foreground">
            {pagesLeft} of {TRIAL_PAGE_ALLOWANCE}
          </strong>{' '}
          pages left
        </span>
        <div
          role="progressbar"
          aria-label="Trial pages left"
          aria-valuemin={0}
          aria-valuemax={TRIAL_PAGE_ALLOWANCE}
          aria-valuenow={pagesLeft}
        >
          <ProgressBar
            progress={(pagesLeft / TRIAL_PAGE_ALLOWANCE) * PERCENT}
            theme={pagesLeft === 0 ? 'error' : 'success'}
            bordered
          />
        </div>
        {trialEndsAt && (
          <time
            dateTime={trialEndsAt}
            title={`Ends ${humanizeDate(trialEndsAt)}`}
          >
            {daysLeftLabel(trialEndsAt)}
          </time>
        )}
      </div>
      <UpgradeButton size="sm" className="w-full" />
    </div>
  )
}
